module.exports = __webpack_public_path__ + "static/DFDLongLogo2-18b5a7cc06cbf3c55029cac57282b8b7.png";